const ADD_RESERVATION_SUCCESS_TEXT = "La réservation a été ajoutée.";
const DELETE_RESERVATION_SUCCESS_TEXT = "La réservation a été supprimée.";
const UPDATE_RESERVATION_SUCCESS_TEXT = "La réservation a été modifiée.";
const CONFIRM_RESERVATION_SUCCESS_TEXT = "La réservation a été confirmée.";
const CANCEL_RESERVATION_SUCCESS_TEXT = "La réservation a été annulée.";

export const ADD_RESERVATION_SUCCESS = ADD_RESERVATION_SUCCESS_TEXT;
export const DELETE_RESERVATION_SUCCESS = DELETE_RESERVATION_SUCCESS_TEXT;
export const UPDATE_RESERVATION_SUCCESS = UPDATE_RESERVATION_SUCCESS_TEXT;
export const CONFIRM_RESERVATION_SUCCESS = CONFIRM_RESERVATION_SUCCESS_TEXT;
export const CANCEL_RESERVATION_SUCCESS = CANCEL_RESERVATION_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/reservations.js